module.exports = __webpack_public_path__ + "static/rosebowbooties-b7c69936aaf433dc7059a5b30f2604eb.jpeg";